import { render, staticRenderFns } from "./BookDateCard.vue?vue&type=template&id=3698ed12&scoped=true&"
import script from "./BookDateCard.vue?vue&type=script&lang=ts&"
export * from "./BookDateCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookDateCard.vue?vue&type=style&index=0&id=3698ed12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698ed12",
  null
  
)

export default component.exports